import { Paper } from "@mui/material";
import { useRouteStoreActions, useRouteResponse, useSelectedRouteIndex } from "../../stores/RouteStore";
import { SelectInput } from "../common/SelectInput";
import { GetRouteName } from "../../services/RouteNameService";

export function RouteSelector() {
    const routeResponse = useRouteResponse();
    const selectedRouteIndex = useSelectedRouteIndex();
    const { setSelectedRouteIndex } = useRouteStoreActions();

    const routes = routeResponse && routeResponse.routes.map( (route, index) => {        
        return GetRouteName(routeResponse, index);
    });
    
    const onSelectRoute = (routeName:string) => {
        if (!routes) {
            return;
        }

        const index = routes.indexOf(routeName);
        setSelectedRouteIndex(index);
    }

    return ( 
        <>
            {routes && 
            <Paper style={{marginTop:"30px"}}>
                <SelectInput<string>
                    allowedValues={routes}
                    value={routes[selectedRouteIndex]}
                    onChange={onSelectRoute}
                    label="Valgt rute"
                />
            </Paper>
            }
        </>
    )

}